import Main from './Main'
import NewPassword from './NewPassword'
import RecoverPassword from './RecoverPassword'
import AuthAdmin from './AuthAdmin'

export default [
  { path: '/auth', name: 'auth', component: Main },
  { path: '/auth_admin', name: 'auth_admin', component: AuthAdmin },
  { path: '/recover_password', name: 'recover_password', component: RecoverPassword },
  { path: '/new_password/:reset_password_token', name: 'new_password', component: NewPassword }
]



// WEBPACK FOOTER //
// ./src/app/pages/auth/routes.js